import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import { Stack, Box } from '@mui/material';
import { IDataGridPanel } from '../Dashboard.model';
import { LayoutItem } from 'react-grid-layout';

interface DataGridPanelProps {
  panel: IDataGridPanel;
  layout?: LayoutItem | undefined;
}

export default function DataGridPanel(props: DataGridPanelProps) {
  const { panel } = props;
  const { title, subtitle, columns, rows } = panel;

  return (
    <Stack
      direction="column"
      width={'100%'}
      height={'100%'}
      sx={{ overflow: 'hidden' }}
    >
      <Stack direction="column" alignItems="flex-start" width={'100%'}>
        <Typography variant="body1" fontWeight={800} fontSize={'0.8em'}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" fontSize={'0.6em'}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      <Box sx={{ flexGrow: 1, width: '100%', minHeight: 0, mt: 1 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[5, 10, 25]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5 },
            },
          }}
          disableRowSelectionOnClick
          sx={{
            border: 'none',
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-row:hover': {
              cursor: 'pointer',
            },
          }}
        />
      </Box>
    </Stack>
  );
}
